export interface ProcessedResultsInterface<T> {
  currentElements: T[];
  totalElements: number;
  isEmpty: boolean;
  isLoading: boolean;
  isLoadingError: boolean;
  isAllLoaded?: boolean;
}
